import React from 'react';

export type EmptyStateVariant = 'default' | 'select-prerequisite' | 'error-fallback';

export interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  body?: React.ReactNode;
  cta?: React.ReactNode;
  variant?: EmptyStateVariant;
  className?: string;
}

export default function EmptyState({
  icon,
  title,
  body,
  cta,
  variant = 'default',
  className,
}: EmptyStateProps) {
  const role = variant === 'error-fallback' ? 'alert' : 'status';
  const wrapperClass = [
    'empty-state',
    `empty-state--${variant}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={wrapperClass} role={role}>
      {icon && <div className="empty-state__icon" aria-hidden="true">{icon}</div>}
      <h3 className="empty-state__title">{title}</h3>
      {body && <p className="empty-state__body">{body}</p>}
      {cta && <div className="empty-state__cta">{cta}</div>}
    </div>
  );
}
